import { mapState } from 'vuex';
import themeToggle from "@/components/assets/themetoggle/index.vue";

import _ from 'underscore';

export default {
	name: 'appmenu',
	props: {
	},

	components : {
		themeToggle
	},

	data : function(){

		return {
			loading : false,
			version : process.env.VUE_APP_VERSION,
			footerFocused : false
		}

	},

	created : () => {

	},

	watch: {
		
		
	},
	computed: mapState({
		auth : state => state.auth,
		mobileview : state => state.mobileview,
		
		active : function(){

			var path = this.$route.path


			var sorted = _.sortBy(this.items, (i) => {
				return i.route ? -i.route.length : 0
			})


			var r = _.find(sorted, function(i){
				
				if(i.route == '/') return path == i.route

				return path.indexOf(i.route) > -1 || (i.childrens && _.find(i.childrens, (i) => {
					return path.indexOf(i) > -1
				}))
			})

			if(r) return r.id

			return ''
		},

		items : function(state){

			var mobile = this.mobileview

			var items = _.filter(this.allitems, (item) => {
				return (typeof item.mobile == 'undefined' || item.mobile == mobile)
			})


			return this.core.user.extendByFeatures(items)

		},

		allitems : function(){

			return [
				
	
				{
					id : 'menu',
					text : 'menu.menu',
					icon : "fas fa-ellipsis-v",
					mobile : true,
					action : this.menu
				},
	
				{
					route : '/profile',
					id : 'profile',
					text : 'menu.profile',
					icon : "fas fa-user",
					mobile : false
				},
	
				/*{
					route : '/faq',
					id : 'faq',
					text : 'caption.helpfooter',
					icon : "far fa-question-circle",
					mobile : false
				}*/
			]
		}
	}),

	methods : {
		explore : function(){
			this.core.vueapi.explore()
		},
		notifications : function(id){
			var c = this.$store.state.updates ? (this.$store.state.updates[id] || 0) : 0

			return c
		},
		/*signout : function(){
			this.core.user.signout()
			this.$router.push('/')
		},*/

		open : function(item){
			if(item.route) {
				this.$router.push(item.route).catch(e => {})
			}

			if(item.action) item.action()
		},

		menu : function(){
			this.core.vueapi.fastmenu()
		},

		mouseoverFooter: function(){
			this.footerFocused = true
		},

		mouseleaveFooter: function(){
			this.footerFocused = false
		}
	}
}